import type { PimFieldValue } from "@thenounproject/lingo-core";
import { createAction } from "@redux/actions/actionCreators";

/**
 * Commits a variant field value. If the committed field value matches the product's
 * field value for the same productFieldId, the reducer collapses it to `source: "inherited"`.
 */
const [useCommitVariantFieldValue, commitVariantFieldValue] = createAction<{
  productUuid: string;
  variantKey: string;
  productFieldId: string;
  value: PimFieldValue;
}>("product/commitVariantFieldValue");

export default useCommitVariantFieldValue;
export { commitVariantFieldValue };
